import { ui } from "@/components/ui";
import NewFisherEntryCard from "@/features/diaries/features/new/components/tracker-type-cards/NewFisherEntryCard";
import type { StatefulObservationViewT } from "@/types/database/observations";
import type { StatefulTrackerViewT } from "@/types/database/trackers";
import NewObservationEntryCard from "./NewObservationEntryCard";
import NewTrackerEntryCard from "./NewTrackerEntryCard";

interface ItemWithStatus {
	id: string;
	name: string;
	is_due: boolean;
	is_locked?: boolean;
	end_date?: string | null;
	is_complete?: boolean;
	type: "tracker" | "observation";
	data: StatefulTrackerViewT | StatefulObservationViewT;
}

interface Props {
	item: ItemWithStatus;
}

const NewEntrySwitch = ({ item }: Props) => {
	if (item.type === "tracker") {
		return <NewTrackerEntryCard tracker={item.data as StatefulTrackerViewT} />;
	}

	return (
		<NewObservationEntryCard
			observation={item.data as StatefulObservationViewT}
		/>
	);
};

export default NewEntrySwitch;
